/*
 * Nokē Devices Constants
 */
export const DEVICE = Object.freeze({
    nokeOne: 'Nokē ONE', // 1A
    nokeContact: 'Nokē Contact', // 2A
    nokeInfinity: 'Nokē Infinitē', // 3A
    nokeVolt: 'Nokē Volt', // 1W, 2E, 3E
    nokeIon: 'Nokē Ion', //4E
    nokeIon2: 'Nokē Ion-2.0', // 5E
    hdPadlock: 'Nokē HD Padlock', // I
    nokePad: 'Nokē Pad', // 3K
    nokeKeypad: 'Nokē Keypad', // 3K
    nokeScreen: 'Nokē Screen', // 4K
    nokeRepeater: 'Nokē Repeater', // 1R
    nokeFob: 'Nokē FOB' // 3F
});
